import {SDrawerOrModal} from "shj-components";
import CodeMirror from '@uiw/react-codemirror';
import {Button, Card, Col, Input, message, Row, Spin} from "antd";
import {SearchOutlined, CopyOutlined} from "@ant-design/icons";

import styles from './index.module.less'
import classNames from "classnames";
import React, {useEffect, useRef} from "react";
import {getFormulaRuleSymbols, getFormulaRuleVariablesList} from "@/services/product.ts";
import {useSetState} from "ahooks";
import {trimStr} from "@/utils/data.ts";
import {javascript} from "@codemirror/lang-javascript";
import {githubLight} from "@uiw/codemirror-theme-github";
import placeholderPlugin from "@/components/CodeMirror/matchDecorator.ts";
import CheckRule from "@/pages/baseProduct/components/RuleModal/CheckRule";

type IProps = {
  tagData?: any[]
  type?: string
  query?: Record<string, any>
  modalProps: Record<string, any>
  onOk: (value: string) => void
  onCancel: () => void
}

export default function RulesModal(props: IProps) {
  const {type = 'priceItem', modalProps, query = {}} = props;
  const editorRef = useRef<{ [key: string]: number | undefined }>({index: undefined})
  const ref = useRef({})
  const [state, setState] = useSetState<any>({
    symbol: [],
    tag: [],
    symbolSearch: '',
    tagSearch: '',
    commonFormula: {},
    code: '',
    loading: false,
    firstUpdate: false,
    ruleOpen: false,
  })

  const isProgrammaticUpdate = useRef(false);

  useEffect(() => {
    getList()
    return () => {
      setState({code: ''})
    }
  }, []);

  useEffect(() => {
    setState({code: state.code?.replace(/^undefined/, '')})
  }, [state.code]);

  useEffect(() => {
    if (modalProps.open) {
      setState({code: modalProps.value ? modalProps.value?.replace('') : '', firstUpload: true})
    }
  }, [modalProps.open, modalProps.value]);

  const getList = () => {
    setState({loading: true})
    Promise.all([getFormulaRuleVariablesList({type, ...query}), getFormulaRuleSymbols()]).then(res => {
      const [tag, symbol] = res;
      setState({tag, symbol, loading: false, commonFormula: symbol[0] || {}})
    }).catch(() => setState({loading: false}))
  }

  const onAddTag = (current) => {
    console.log(current,'current');
    console.log(state.code,'state.code');
    console.log(editorRef.current?.index,'editorRef.current?.index');
    const value = state.code;
    const index = editorRef.current?.index
    const insertValue = `[[${current.name}]]`
    let newValue = value + insertValue
    console.log(index)
    if (typeof index === "number") {
      newValue = value.slice(0, index) + insertValue + value.slice(index)
      const currentIndex = index + (current.name.length) + 4
      console.log(currentIndex,'currentIndex');
      ref.current?.view?.dispatch?.({
        changes: {from: index, insert: insertValue},
        selection: {anchor: currentIndex},
      })
    }
    setState({code: newValue})
  }

  const onChangeDesc = (current) => {
    console.log(current,'current');
    console.log(state.code,'state.code');
    console.log(editorRef.current?.index,'editorRef.current?.index');
    setState({commonFormula: current})
    const index = editorRef.current?.index
    const value = state.code;
    let newValue = value + current.code
    if (index) {
      newValue = value.slice(0, index) + current.code + value.slice(index)
      const currentIndex = index + current.code.length
      console.log(currentIndex,'currentIndex');
      ref.current?.view?.dispatch?.({
        changes: {from: index, insert: current.code},
        selection: {anchor: currentIndex},
      })
    }
    setState({code: newValue})
  }

  const onChangeValue = (value) => {
    // 如果是程序触发的更新，不需要再处理
    if (isProgrammaticUpdate.current) {
      return;
    }

    setState({ code: value });

    // 删除内容时需要同步更新编辑器视图
    if (value.length < state.code.length) {
      isProgrammaticUpdate.current = true;
      ref.current?.view?.dispatch?.({
        changes: { from: 0, to: ref.current.view.state.doc.length, insert: value },
        selection: { anchor: value.length },
      });
      // 确保标志位在当前更新结束后重置
      setTimeout(() => {
        isProgrammaticUpdate.current = false;
      }, 0);
    }
  }

  const onCopy = () => {
    if (!state.code) return message.error('没有可复制内容')
    navigator.clipboard.writeText(state.code).then(() => {
      message.success('复制成功');
    });
  }

  // console.log('value---->', state.code)
  return <SDrawerOrModal
      title={'编辑规则'}
      open={modalProps.open}
      mode={modalProps.mode}
      onCancel={props.onCancel}
      antdProps={
        {
          footer: [<Button onClick={() => setState({ruleOpen: true})} disabled={!state.code}>校验</Button>,
            <Button onClick={props.onCancel}>取消</Button>,
            <Button type={'primary'} onClick={() => {
              props.onOk?.(state.code);
              props.onCancel?.()
            }}>保存</Button>]
        }
      }
  >
    <Spin spinning={state.loading}>
      <Card title={'公式='} className={styles.card_box}
            extra={<div className={styles.copy_btn} onClick={onCopy}><CopyOutlined/>复制</div>}>
        <div className={styles.code_box}>
          <CodeMirror
              value={state.code}
              ref={ref}
              height="200px"
              basicSetup={{
                lineNumbers: false,
                foldGutter: false,
              }}
              onChange={onChangeValue}
              onStatistics={(e) => {
                editorRef.current.index = e.ranges[0]?.to
              }}
              extensions={[javascript(), githubLight, placeholderPlugin]}
              // onUpdate={(update: any) => {
              //   if (update.docChanged) {
              //     onChangeValue(update.state.doc.toString());
              //   }
              // }}
          />
        </div>
        <Row align={'stretch'}>
          <Col span={10} className={styles.col_flex_box}>
            <Input value={state.tagSearch}
                   onChange={(e) => setState({tagSearch: trimStr(e.target.value)})}
                   prefix={<SearchOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                   className={styles.search_box}
                   placeholder={'搜索变量'}/>
            <div className={classNames([styles.content_box, styles.flex_gap])}>
              {state.tag
                  .filter(item => item.name.includes(state.tagSearch))
                  .map(item => <Button key={item.id} onClick={() => onAddTag(item)}>{item.name}</Button>)}
            </div>
          </Col>
          <Col span={6} className={styles.col_flex_box}>
            <Input value={state.symbolSearch}
                   onChange={(e) => setState({symbolSearch: trimStr(e.target.value)})}
                   prefix={<SearchOutlined style={{color: 'rgba(0,0,0,.25)'}}/>}
                   className={styles.search_box}
                   placeholder={'搜索函数'}/>
            <div className={styles.content_box}>
              {state.symbol
                  .filter(item => item.name.includes(state.symbolSearch) || item.code.includes(state.symbolSearch))
                  .map(item => <div key={item.id} className={styles.fun_item} onClick={() => onChangeDesc(item)}>
                    <p>{item.code}</p>
                    <p className={styles.name}>{item.name}</p>
                  </div>)}
            </div>
          </Col>
          <Col span={8} className={styles.col_flex_box}>
            <div className={styles.desc_title_box}>{state.commonFormula?.code}</div>
            <div className={classNames([styles.content_box, styles.desc_box])}>{state.commonFormula?.desc}</div>
          </Col>
        </Row>
      </Card>
    </Spin>
    {state.ruleOpen && <CheckRule type={type}
                                  code={state.code}
                                  open={state.ruleOpen}
                                  onCancel={() => setState({ruleOpen: false})}
                                  mode={'modal'}/>}
  </SDrawerOrModal>
}